import Icon from "@visa/vds/icon";
import Td from "@visa/vds/td";
import Tr from "@visa/vds/tr";
import { SubscriptionStatus } from "_constants/SubscriptionConstants";
import { DateHelper } from "_helpers/DateHelper";
import { SubscriptionHelper } from "_helpers/SubscriptionHelper";
import MCSPagedTable from "components/MCSPagedTable";
import SubscriptionStatusBadge from "components/subscription/SubscriptionStatusBadge";
import React, { useState } from "react";

const ManageSubscriptionTable = (props) => {
  const tableData = props.tableData;
  const fetchData = props.fetchData;
  const handleExportAll = props.handleExportAll;
  const [selectedPage, setSelectedPage] = useState(1);
  const [sortBy, setSortBy] = useState(props.defaultSortBy);
  const [desc, setDesc] = useState(props.defaultDesc);
  const [filter, setFilter] = useState(props.defaultFilter);
  const [searchVal, setSearchVal] = useState();

  const filterOptions = [
    { value: SubscriptionStatus.Pending, label: "Pending" },
    { value: SubscriptionStatus.Active, label: "Active" },
    { value: SubscriptionStatus.Cancelled, label: "Canceled" },
    { value: SubscriptionStatus.Expired, label: "Expired" },
  ]

  let colHeaders = [
    { displayName: "Product Name", name: "ProductName", orderable: true },
    { displayName: "Subscription Name", name: "SubscriptionName", orderable: true },
    { displayName: "Subscription Start Date", name: "StartDate", orderable: true },
    { displayName: "Subscription Last Date", name: "EndDate", orderable: true },
    { displayName: "Business Name", name: "OrganizationName", orderable: true },
    { displayName: "Region", name: "RegionName", orderable: false },
    { displayName: "BID", name: "BID", orderable: false },
    { displayName: "Order Reference", name: "OrderId", orderable: false },
    { displayName: "Status", name: "subscriptionStatusName", orderable: false },
    { displayName: "", name: "action", orderable: false },
  ];

  function fetch(page, sortBy, desc, filter, search) {
    fetchData(page, sortBy, desc, filter, search);
  }

  function handleFilterSubscriptionStatus(e) {
    setSelectedPage(1);
    let newFilter = { ...filter, subscriptionStatus: e.target.value };
    setFilter(newFilter);
    fetch(1, sortBy, desc, newFilter, searchVal);
  }

  const handleSearchChange = async (searchBy) =>{
    fetch(1, sortBy, desc, filter, searchBy);
    setSelectedPage(1);
}

  const handleSortChange = async (sortBy = null, desc = false) => {
    fetch(selectedPage, sortBy, desc, filter, searchVal);
  };

  const handlePageChange = (newPage) => {
    setSelectedPage(newPage);
    fetch(newPage, sortBy, desc, filter, searchVal);
  };

  function getSubscriptionTypeDesc(subscriptionType) {
    let desc = SubscriptionHelper.GetSubscriptionTypeDescription(subscriptionType);
    if (desc != null && desc !== "") return " (" + desc + ")";
    return "";
  }

  return (
    <>
      {tableData && (
        <MCSPagedTable
          size={"compact"}
          colHeaders={colHeaders}
          useFilterBar={true}
          filterBarDefaultValue={SubscriptionStatus.Active}
          filterBarLabel={"Filter by Subscription Status"}
          handleFilterBarChange={handleFilterSubscriptionStatus}
          filterOptions={filterOptions}
          useExportAll={props.enableExport}
          handleExportAll={handleExportAll}
          useSearchBar={true}
          handleSearchChange={handleSearchChange}
          searchVal={searchVal}
          setSearchVal={setSearchVal}
          searchHelpText={"Search Business Name/BID"}
          usePagination={true}
          selectedPage={selectedPage}
          setSelectedPage={handlePageChange}
          ordered={sortBy}
          setOrdered={setSortBy}
          sortData={handleSortChange}
          isDsc={desc}
          setDsc={setDesc}
          totalPages={props.totalPage}
          pageSize={props.pageSize}
          totalCount={props.totalCount}
          tableData={
            tableData &&
            tableData.map((row, key) => (
              <Tr key={key}>
                <Td>{row.productName}</Td>
                <Td>
                  {row.subscriptionName +
                    getSubscriptionTypeDesc(row.subscriptionType)}
                </Td>
                <Td>{DateHelper.ToFormattedDate(row.startDate)}</Td>
                <Td>{DateHelper.ToFormattedDate(row.endDate)}</Td>
                <Td>{row.organizationName}</Td>
                <Td>{row.regionName}</Td>
                <Td>{row.bid}</Td>
                <Td>{row.orderId}</Td>
                <Td class="word-nobreak">
                  <SubscriptionStatusBadge
                    startDate={row.startDate}
                    status={row.subscriptionStatus}
                    statusName={row.subscriptionStatusName}
                  />
                </Td>
                <Td>
                  <Icon
                    data-id={row.id}
                    onClick={() => props.handleClickAction(row)}
                    className="vss-clickable-icon"
                    name="settings"
                    resolution="low"
                  />
                </Td>
              </Tr>
            ))
          }
        />
      )}
    </>
  );
};
export default ManageSubscriptionTable;
